import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '../../../hooks/redux';
import './Footer.scss';
import { Copyright } from './Copyright';
import { Logo } from './Logo';
import { Contacts } from '../Contacts';
import { Socials } from './Socials';
import { BasicButton } from '../buttons/BasicButton/BasicButton';
import { ModalVariants } from '../../../models/Common';
import { modalSlice } from '../../../store/reducers/ModalSlice';

const Footer: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { selectedLanguage } = useAppSelector((state) => state.langReducer);

  const { openModal } = modalSlice.actions;

  const handleFeedback = () => {
    dispatch(openModal({ modalVariants: ModalVariants.AnonymousFeedback }));
  };

  return (
    <footer className="page-footer ">
      <div className="page-footer__container container">
        <div className="page-footer__info-section">
          <Logo lang={selectedLanguage} />
          <div className="socials__leave-feedback">
            <BasicButton className="btn-feedback" handleClick={handleFeedback}>
              <span>{t('feedbackAndSuggestions.open')}</span>
            </BasicButton>
          </div>
          <Contacts />
          <Socials />
        </div>
        <Copyright lang={selectedLanguage} />
      </div>
    </footer>
  );
};

export default Footer;
